@if (text) {
  <article class="text-container">
    <div class="expand-btn" Accordion>
      <i class="icon-arrow"></i>
    </div>
    <div class="text" [innerHTML]="text | safe:'html'"></div>
  </article>
}
